module.exports = __webpack_public_path__ + "static/media/legal-files.0b3e9dba.zip";